const handledOrderPendingProcessModalExposureSessions = new Set<string>();

export const hasHandledOrderPendingProcessModalExposureSession = (dedupeKey: string) =>
  handledOrderPendingProcessModalExposureSessions.has(dedupeKey);

export const markOrderPendingProcessModalExposureSessionHandled = (dedupeKey: string) => {
  handledOrderPendingProcessModalExposureSessions.add(dedupeKey);
};

export const clearOrderPendingProcessModalExposureSessionsForTests = () => {
  handledOrderPendingProcessModalExposureSessions.clear();
};
